import { TRootState } from "Redux/Reducers";

export const getEventCategory = (id: string) => (state: TRootState) => state.eventCategory.entries[id];
